import React, { Component } from 'react';
import Form from './Form';
import Edit from '../../common/Edit';

export default class ProductEdit extends Component {
  render() {
    return (
      <Edit
        resource={'ticketProduct'}
        resourceId={this.props.params.id}
        component={Form}
      />
    );
  }
}
